import { IApplicationState } from '../types/redux';

export function getDeviceType(state: IApplicationState) {
  return state.page.deviceType;
}
